// extracted by mini-css-extract-plugin
module.exports = {"social-icons":"_3XIUi","social-icon":"_1YLeT","link":"_13GxD"};